import React from 'react';

interface IProps {
	children: React.ReactNode;
	testId: string;
}

export const ListingPage: React.FC<IProps> = ({ children, testId }) => (
	<div className="min-h-full p-4 flex flex-col gap-4" data-test={testId}>
		{children}
	</div>
);
